import React from 'react';
import styled from 'styled-components';
import { Coord, Dimensions } from '@99designs/browser';
import ImageTransparencyTile from '../../../../../images/ImageTransparencyTile.png';

const FilePaneImage = styled.img`
    background-image: url(${ImageTransparencyTile});
    position: absolute;
`;

interface ImageProps {
    artboardOrigin: Coord;
    imageSize: Dimensions;
    scale: number;
    previewUrl: string;
    artboardSize: Dimensions;
}

function Image({ artboardOrigin, imageSize, scale, previewUrl, artboardSize }: ImageProps) {
    /*
        Wait for artboardSize to be set as the image position will be incorrect otherwise.
        Artboard is always at least 320 pixels high.  As on mobile, it will equal the viewPort width.
    */
    if (artboardSize.height < 320) {
        return null;
    }

    return (
        <FilePaneImage
            alt=""
            role="presentation"
            src={previewUrl}
            key={previewUrl}
            style={{
                left: `${artboardOrigin.x}px`,
                top: `${artboardOrigin.y}px`,
                width: `${imageSize.width * scale}px`,
                height: `${imageSize.height * scale}px`,
            }}
            data-testid="FilePaneImage"
        />
    );
}

export default Image;
